import { DATA_SCOPES } from "./filterConstants";

export class FilterBase {
  constructor(filterName, filterType, dataType, dataScopes, information, visibility=true, restrictedToScope=false, filterable=true) {
    this.filterName = filterName;
    this.filterType = filterType;
    this.dataType = dataType;
    this.dataScopes = dataScopes;
    this.restrictedToScope = restrictedToScope;
    this.information = information;
    this.visibility = visibility;
    this.filterable = filterable;
    this.value = null;
    this.from = null;
    this.to = null;
    this.element = null;
    this.allowCompare = false;
    this.compareWith = null;
    this.comparisonFailurePrefix = null;
  }

  setValue(value) {
    this.value = value;
  }

  setFrom(from) {
    this.from = from;
  }

  setTo(to) {
    this.to = to;
  }

  setElement(element) {
    this.element = element;
  }

  setCompareWithParameters(compareWith, comparisonFailurePrefix) {
    this.compareWith = compareWith;
    this.comparisonFailurePrefix = comparisonFailurePrefix;
    this.allowCompare = true;
  }

  compare(a, b) {
    const [formattedA, formattedB] = this.formatCompareData(a[this.filterType], b[this.filterType]);
    if ((!formattedA && formattedA !== 0) && (!formattedB && formattedB !== 0)) {
      return 0;
    } else if ((!formattedA && formattedA !== 0)) {
      return -1;
    } else if ((!formattedB && formattedB !== 0)) {
      return 1;
    }
  
    if (formattedB < formattedA) {
      return -1;
    }
    if (formattedB > formattedA) {
      return 1;
    }
    return 0;
  }

  formatCompareData(a, b) {
    throw new Error("Overwrite function");
  }

  additionalFilters(data) {
    throw new Error("Overwrite function");
  }

  formatData(device, deviceGroups, insight, insightMetrics, update, alert, user, alg_meta, alg_release) {
    throw new Error("Overwrite function");
  }

  filterData(data) {
    if (this.restrictedToScope && !this.dataScopes.includes(DATA_SCOPES.ALL)) {
      const passedData = data.filter((row) => !(this.dataScopes.includes(row.data_type)))
      const filteredData = data.filter((row) => (this.dataScopes.includes(row.data_type)))
      return [...passedData, ...this.additionalFilters(filteredData)]
    }
    return this.additionalFilters(data);
  }

}